import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import OnboardingLayout from '../../components/onboarding/OnboardingLayout';
import {
  getCurrentPositionFastWithAccuracy,
  getCurrentPositionAccurate,
} from '../../utils/location';
import { useUserLocation } from '../../contexts/UserLocationContext';
import Button from '../../components/ui/Button';

const LocationPermission = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setUserLocationManually } = useUserLocation();

  const refineLocationInBackground = () => {
    getCurrentPositionAccurate()
      .then((position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        setUserLocationManually({ lat, lng, city: null, district: null });
      })
      .catch(() => {});
  };

  /** يطلب الموقع فيُظهر حوار النظام؛ الزر «متابعة» فقط (متطلبات مراجعة Apple 5.1.1). */
  const handleContinue = async () => {
    setLoading(true);
    try {
      const { lat, lng } = await getCurrentPositionFastWithAccuracy();
      setUserLocationManually({ lat, lng, city: null, district: null });
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('locationPermissionChoice', 'granted');
      }
      refineLocationInBackground();
    } catch (_) {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('locationPermissionChoice', 'denied');
      }
      refineLocationInBackground();
    } finally {
      setLoading(false);
      navigate('/onboarding/notifications', { replace: true });
    }
  };

  return (
    <OnboardingLayout>
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="text-center"
      >
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
            <MapPin className="w-10 h-10 text-primary" strokeWidth={2} />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-3">
          اعثر على المصورين بالقرب منك
        </h1>
        <p className="text-slate-600 mb-8 leading-relaxed">
          نحتاج موقعك لعرض المصورين القريبين منك وتسريع عملية الحجز.
        </p>
        <div className="flex flex-col gap-3">
          <Button
            type="button"
            onClick={handleContinue}
            disabled={loading}
            className="w-full"
            style={{ backgroundColor: 'var(--color-button)' }}
          >
            {loading ? 'جاري الطلب...' : 'متابعة'}
          </Button>
        </div>
      </motion.div>
    </OnboardingLayout>
  );
};

export default LocationPermission;
